var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"mw-100"},_vm._l((_vm.fields),function(field){return _c('span',{key:field},[_c('number-flip',{attrs:{"value":_vm.getValue(field, _vm.value),"color":_vm.color,"width":_vm.width}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }